// CreateLevelContent.tsx
import type React from "react";
import {useEffect, useState} from "react";
import {useAuthState} from "react-firebase-hooks/auth";

import {createDefaultWipLevelEntityV2} from "@repo/shared";

import {useCreateWipLevelV2} from "~/api/hooks/useWipLevelV2";
import CustomButton from "~/component/common/CustomButton";
import {auth} from "~/firebase/firebase";

import ButtonSpinner from "../../../../component/spinner/ButtonSpinner";

interface CreateLevelContentProps {
  closeModal: () => void;
}

const CreateLevelContent: React.FC<CreateLevelContentProps> = ({
  closeModal,
}) => {
  const [user] = useAuthState(auth);
  const [newLevelName, setNewLevelName] = useState("");

  const {
    mutate: createWipLevel,
    isPending: isCreating,
    isSuccess,
    reset,
  } = useCreateWipLevelV2();

  useEffect(() => {
    if (isSuccess) {
      setNewLevelName("");
      closeModal();
      reset();
    }
  }, [isSuccess, closeModal, reset]);

  const handleCreate = () => {
    if (!user) return;
    const level = createDefaultWipLevelEntityV2(user.uid, newLevelName);
    createWipLevel({
      key: {},
      data: level,
    });
  };

  return (
    <div className="w-full text-white">
      <h2 className="text-2xl mb-4">New Level</h2>
      <input
        type="text"
        value={newLevelName}
        onChange={(e) => setNewLevelName(e.target.value)}
        placeholder="Level Name"
        className="w-full mb-4 p-2 border rounded bg-white text-black"
      />
      <div className="flex justify-end mt-4">
        <CustomButton
          className={`bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded ${
            !newLevelName ? "opacity-50 cursor-not-allowed" : ""
          }`}
          onClick={handleCreate}
          disabled={!newLevelName || isCreating}
        >
          <ButtonSpinner isLoading={isCreating} />
          Create
        </CustomButton>
      </div>
    </div>
  );
};

export default CreateLevelContent;
